import * as effects from 'redux-saga/effects';
import { api } from '@REST/api';
import { handleError } from '@bus/ui/saga/workers/handleError';
import { throwError } from '@bus/ui/saga/workers/throwError';

import { createdImagesActions } from '../../actions';
import { FillImageStudioFacesActionPayload } from '@bus/createdImages/typedefs';

export function* fetchImageStudioFaces() {
  try {
    yield effects.put(createdImagesActions.startFetching());
    const response: Response = yield effects.apply(api, api.get, [
      { endpoint: 'image-studio/faces/' },
    ]);
    if (!response.ok) {
      yield throwError(response);
    }

    const data: FillImageStudioFacesActionPayload = yield effects.call([
      response,
      'json',
    ]);
    yield effects.put(createdImagesActions.fillImageStudioFaces(data));
  } catch (e) {
    yield handleError(e);
  } finally {
    yield effects.put(createdImagesActions.stopFetching());
  }
}
